// @docs https://[domain]/api/v1/docs
export default {
  List: "/contract-types",
  Detail: "/contract-types",
  Update: "/contract-types",
  Create: "/contract-types",
  ListShort: "/contract-types/short",
};
